import { Divider, Grid } from "@mui/material";
import { useEnvContext, useWebStoreContext } from "contexts";
import { FeaturesFlags } from "helpers";
import SetAddLoyaltyPointsDialog from "../SetAddLoyaltyPointsDialog";

export const PoisBountyTools = () => {
	const { userTracker } = useWebStoreContext();
	const { isFeatureFlagEnabled } = useEnvContext();

	return (
		<>
			{userTracker && isFeatureFlagEnabled(FeaturesFlags.POIS_BOUNTY_V2) && (
				<>
					<h1>Pois Bounty</h1>
					<div>
						<Grid container direction="row" spacing={0.5}>
							<Grid item>
								<SetAddLoyaltyPointsDialog />
							</Grid>
						</Grid>
					</div>
					<br />

					<Divider />
				</>
			)}
		</>
	);
};
